module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-body"
  }, [_c('h2', [_vm._v("Profile")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }]
  }, [_vm._v("Vorname: " + _vm._s(_vm.user.first_name))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }]
  }, [_vm._v("Nachname: " + _vm._s(_vm.user.last_name))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.email),
      expression: "user.email"
    }]
  }, [_vm._v("E-Mail-Adresse: " + _vm._s(_vm.user.email))]), _vm._v(" "), _c('p', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.nickname_change),
      expression: "!nickname_change"
    }]
  }, [_vm._v("Spitzname: " + _vm._s(_vm.user.nick_name))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nickname_change),
      expression: "nickname_change"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nickname),
      expression: "nickname"
    }],
    staticClass: "ipt ipt--change",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.email || _vm.user.first_name),
      expression: "user.email || user.first_name"
    }],
    staticClass: "btn btn--change",
    on: {
      "click": _vm.changenickname
    }
  }, [_vm._v(_vm._s(_vm.change_button_text))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--facebook",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fbconnect
    }
  }, [_vm._v("\n    " + _vm._s(_vm.facebook_button_text) + "\n  ")]), _vm._v(" "), (!_vm.user.email) ? _c('div', [_c('button', {
    staticClass: "btn btn--email",
    attrs: {
      "type": "button",
      "disabled": !(_vm.email_address.indexOf('@') > -1) && _vm.email_add_address
    },
    on: {
      "click": _vm.addemail
    }
  }, [_vm._v("\n      " + _vm._s(_vm.add_email_text) + "\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.email_add_address),
      expression: "email_add_address"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email_address),
      expression: "email_address"
    }],
    staticClass: "ipt ipt--email",
    attrs: {
      "type": "email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.email_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email_address = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn--logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n    Logout\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b310b4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile.vue
// module id = 210
// module chunks = 1